/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureeventtranslation3Inputs */

const en_aifeatureeventtranslation3 = /** @type {(inputs: Aifeatureeventtranslation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description translation`)
};

const de_aifeatureeventtranslation3 = /** @type {(inputs: Aifeatureeventtranslation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung übersetzen`)
};

/**
* | output |
* | --- |
* | "Description translation" |
*
* @param {Aifeatureeventtranslation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureeventtranslation3 = /** @type {((inputs?: Aifeatureeventtranslation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureeventtranslation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureeventtranslation3(inputs)
	return de_aifeatureeventtranslation3(inputs)
});
export { aifeatureeventtranslation3 as "aiFeatureEventTranslation" }